import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('@/views/Home.vue'),
    exact: true
  },
  {
    path: '/video-translation',
    name: 'VideoTranslation',
    component: () => import('@/views/VideoTranslation.vue')
  },
  {
    path: '/video-swapping',
    name: 'VideoSwapping',
    component: () => import('@/views/VideoSwapping.vue')
  },
  {
    path: '/sound-cloning',
    name: 'SoundCloning',
    component: () => import('@/views/SoundCloning.vue')
  },
  {
    path: '/pricing',
    name: 'Pricing',
    component: () => import('@/views/Pricing.vue')
  },
  {
    path: '/contact',
    name: 'Contact',
    component: () => import('@/views/Contact.vue')
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/auth/Login.vue'),
    meta: { title: '登录 - KisiAI' }
  },
  {
    path: '/workspace',
    component: () => import('@/views/workspace/WorkspaceLayout.vue'),
    meta: { requiresAuth: true },
    children: [
      {
        path: '',
        name: 'Dashboard',
        component: () => import('@/views/workspace/Dashboard.vue'),
        meta: { title: '工作台' }
      },
      {
        path: 'video-translation',
        name: 'WorkspaceVideoTranslation',
        component: () => import('@/views/workspace/VideoTranslation.vue'),
        meta: { title: '视频翻译' }
      },
      {
        path: 'video-swapping',
        name: 'WorkspaceVideoSwapping',
        component: () => import('@/views/workspace/VideoSwapping.vue'),
        meta: { title: '视频换脸' }
      },
      {
        path: 'sound-cloning',
        name: 'WorkspaceSoundCloning',
        component: () => import('@/views/workspace/SoundCloning.vue'),
        meta: { title: '声音克隆' }
      },
      {
        path: 'subtitle-erasing',
        name: 'WorkspaceSubtitleErasing',
        component: () => import('@/views/workspace/SubtitleErasing.vue'),
        meta: { title: '字幕擦除' }
      },
      {
        path: 'text-extract',
        name: 'WorkspaceTextExtract',
        component: () => import('@/views/workspace/TextExtract.vue'),
        meta: { title: '视频内容提取' }
      },
      {
        path: 'text-to-speech',
        name: 'WorkspaceTextToSpeech',
        component: () => import('@/views/workspace/TextToSpeech.vue'),
        meta: { title: '文本转语音' }
      },
      {
        path: 'image-face-swap',
        name: 'WorkspaceImageFaceSwap',
        component: () => import('@/views/workspace/ImageFaceSwap.vue'),
        meta: { title: '图片换脸' }
      },
      {
        path: 'tasks',
        name: 'WorkspaceTasks',
        component: () => import('@/views/workspace/Tasks.vue'),
        meta: { title: '任务列表' }
      },
      {
        path: 'orders',
        name: 'WorkspaceOrders',
        component: () => import('@/views/workspace/Orders.vue'),
        meta: { 
          title: '订单管理',
          requiresAuth: true,
          requiresAdmin: true
        }
      },
      {
        path: 'products',
        name: 'WorkspaceProducts', 
        component: () => import('@/views/workspace/Products.vue'),
        meta: {
          title: '产品管理',
          requiresAuth: true,
          requiresAdmin: true
        }
      },
      {
        path: 'users',
        name: 'WorkspaceUsers',
        component: () => import('@/views/workspace/UserManagement.vue'),
        meta: {
          title: '用户管理',
          requiresAuth: true,
          requiresAdmin: true
        }
      },
      {
        path: 'audit-logs',
        name: 'WorkspaceAuditLogs',
        component: () => import('@/views/workspace/AuditLog.vue'),
        meta: {
          title: '审计日志',
          requiresAuth: true,
          requiresAdmin: true
        }
      },
      {
        path: 'dict',
        name: 'WorkspaceDictType',
        component: () => import('@/views/workspace/DictType.vue'),
        meta: {
          title: '字典管理',
          requiresAuth: true,
          requiresAdmin: true
        }
      },
      {
        path: 'dict-data/:code',
        name: 'WorkspaceDictData',
        component: () => import('@/views/workspace/DictData.vue'),
        meta: {
          title: '字典数据',
          requiresAuth: true,
          requiresAdmin: true
        }
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      // 如果是浏览器的前进/后退按钮触发的导航，则使用保存的位置
      return savedPosition
    } else {
      // 其他情况下，滚动到顶部
      return { x: 0, y: 0 }
    }
  }
})

router.beforeEach(async (to, from, next) => {
  document.title = to.meta.title || 'KisiAI'
  
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.getters['auth/isAuthenticated']) {
      next({ name: 'Login', query: { redirect: to.fullPath } })
    } else {
      if (to.matched.some(record => record.meta.requiresAdmin)) {
        const isAdmin = store.getters['auth/isAdmin']
        if (!isAdmin) {
          next({ name: 'Dashboard' })
          return
        }
      }
      
      if (!store.getters['auth/hasUserProfile']) {
        try {
          await store.dispatch('auth/fetchUserProfile')
        } catch (error) {
          console.error('Failed to fetch user profile:', error)
        }
      }
      next()
    }
  } else {
    next()
  }
})

export default router 